import { useEffect } from 'react'
import { tokenManager } from '@/api/client'
import { useBudgetAlertsStore } from '@/stores/useBudgetAlertsStore'
import { useMyBusinessStore } from '@/stores/useMyBusinessStore'
import { useNotificationsStore } from '@/stores/useNotificationsStore'
import { useJobsStore } from '@/stores/useJobsStore'

/**
 * Loads what the shell chrome shows (businesses, budget alerts, notifications,
 * jobs)
 * and keeps it fresh. Mount once, in the shell, so it runs on every screen.
 */
export function useShellPolling() {
  const fetchBusinesses = useMyBusinessStore((state) => state.fetch)
  const fetchAlerts = useBudgetAlertsStore((state) => state.fetchAlerts)
  const fetchNotifications = useNotificationsStore((state) => state.fetchNotifications)

  useEffect(() => {
    const refresh = () => {
      void fetchBusinesses()
      fetchAlerts()
      fetchNotifications()
      void useJobsStore.getState().loadJobs()
    }
    void fetchBusinesses()
    fetchAlerts()
    fetchNotifications()
    // 60s fallback cadence — real-time delivery rides /events/stream (SSE);
    // skip when the tab is hidden, and stop the instant the session token is
    // cleared instead of polling a dead session.
    const interval = setInterval(() => {
      if (document.visibilityState === 'hidden') return
      if (!tokenManager.hasValidToken()) return
      refresh()
    }, 60000)
    // Converge on refocus so a backgrounded tab's badge doesn't drift.
    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return
      if (!tokenManager.hasValidToken()) return
      refresh()
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      clearInterval(interval)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
